import Constant from '@/const';
import axios from 'axios';

const getDinkesDataByReferralPatient = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/report/visitors/dinkes/referral-patient'),
      {
        params,
      },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getDinkesDataByReferralPatient;
